import { string, email, number } from "../../../helpers/validations";

export const validationMap = {
  legalBenefitTypeId: (val) => string(val.value),
  dueDate: string,
  frequency: (val) => string(val.value),
  amount: number,
  employees: (val) => val.every((v) => string(v.value)),
};
